import { Banner, CTA, HorizontalWordLoop } from '@/components'
import mailer from '../../assets/images/services/gorilla.png'
import animation from '../../assets/animations/Cart.json'
import { Fade, JackInTheBox } from "react-awesome-reveal";
import { Helmet } from 'react-helmet-async'
import { FAQSection } from '@/components/FaqSection'
import { RootState, store } from '@/store/store';
import { useSelector } from 'react-redux';
import { getStorageImagePath } from '@/utils/utils';
import { ServiceSection } from '@/components/ServiceSection';
import { SeoTags } from '@/components/SeoTags';

export const EcommerceSolutions = () => {

    const appConfig = useSelector((state: RootState) => state.app.config);
    const page = appConfig?.services?.find(service => service?.key === 'ecommerce-solutions')
    if (!page) return;

    const bannerImage = getStorageImagePath(page.banner_image) ?? mailer;
    const ctaImage = getStorageImagePath(page.cta_image);

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Service",
        serviceType: "Ecommerce Development",
        name: "Ecommerce Solutions",
        provider: {
            "@type": "Organization",
            name: "Darperso Digital",
            url: "https://darperso.com"
        },
        areaServed: "Worldwide",
        url: "https://darperso.com/services/ecommerce-solutions",
        description: "Darperso builds ecommerce solutions that help businesses launch online stores, improve customer journeys, and turn more visitors into customers."
    };

    return <>

        <SeoTags
            page={page}
            pageType={"service"}
            seo_settings={store.getState().app.config.seo_settings}
        />

        <JackInTheBox triggerOnce={true} delay={1000}>
            <Banner
                subtitle={page.banner_intro_text}
                title={page.banner_title}
                image={bannerImage}
                description={page.banner_description}
            />
        </JackInTheBox>
        <Fade triggerOnce={true} delay={100}>
            <HorizontalWordLoop title={page.looping_text} />
        </Fade>

        <ServiceSection
            lottie={animation}
            title={page.section_title}
            content={page.section_content}
        />

        <FAQSection
            title={page?.faq_title}
            subtitle={page?.faq_subtitle}
            items={page?.faqItems}
        />

        <CTA
            title={page.cta_title}
            ctaText={page.cta_button_text}
            description={page.cta_description}
            image={ctaImage}
        />

    </>

}
